module.exports = __webpack_public_path__ + "img/mclogoV2.1.dda1d315.svg";